import { ToastData, updateToast } from "state";
import { useAppDispatch } from "state/hooks";

interface HookData extends ToastData {
  timeOut?: number;
  callback?: () => void;
}

const useToast = () => {
  const dispatch = useAppDispatch();

  const openToast = (data: HookData) => {
    const { show, heading, text, type, timeOut = 3000, callback, onClose } = data;
    dispatch(
      updateToast({
        show,
        heading,
        text,
        type,
        onClose,
      })
    );

    setTimeout(() => {
      dispatch(
        updateToast({
          show: false,
          heading: "",
          text: "",
          type: "info",
        })
      );

      callback && callback();
    }, timeOut);
  };

  const toast = ({ title, type }: { title: string; type: "success" | "error" | "info" | "warning" }) => {
    openToast({
      show: true,
      heading: type === "error" ? "Error" : type === "success" ? "Success" : "Info",
      text: title,
      type,
      timeOut: 3000,
    });
  };

  return { openToast, closeToast: () => dispatch(updateToast({ show: false, heading: "", text: "", type: "info" })), toast };
};

export { useToast };
